<div class="button-toolbar">
    <div style="display: flex; justify-content: space-between; align-items:flex-start;">
        <div style="align-items:flex-start">
            <div class="btn-group" role="group">
                <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
                    <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        Reset
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                                title="Reload the application from the server">
                                <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
                            </span>
                        </li>
                        <li>
                            <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                                title="Reset the section currently selected">
                                <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
                            </span>
                        </li>
                    </ul>
                </span>
            </div>
            <button *ngIf="!(postLoading$ | async)" type="button" class="btn btn-light"
                aria-label="Send selected ZIP file" title="Send selected ZIP file" (click)="onButtonAction('send','')">
                Send
            </button>
        </div>
    </div>
</div>